const pendingScrollRestore = new Map();

const restoreSetOptionSliderScroll = (form) => {
  const root = form.closest('product-rerender') || document;

  for (const slider of root.querySelectorAll('.variant-picker__set-options--slider[data-set-option-slider]')) {
    const key = `${form.id}:${slider.getAttribute('data-set-option-slider')}`;
    const scrollLeft = pendingScrollRestore.get(key);

    if (scrollLeft === undefined) continue;

    slider.scrollLeft = scrollLeft;
    pendingScrollRestore.delete(key);
  }
};

const bindSetOptionSliderScroll = (form) => {
  if (form.dataset.setOptionSliderScrollBound === 'true') return;

  form.dataset.setOptionSliderScrollBound = 'true';

  form.addEventListener(
    'product:rerender',
    () => {
      const root = form.closest('product-rerender') || document;

      for (const slider of root.querySelectorAll('.variant-picker__set-options--slider[data-set-option-slider]')) {
        const key = `${form.id}:${slider.getAttribute('data-set-option-slider')}`;
        pendingScrollRestore.set(key, slider.scrollLeft);
      }
    },
    true
  );

  form.addEventListener('product:rerender', () => {
    requestAnimationFrame(() => {
      restoreSetOptionSliderScroll(form);
    });
  });
};

const initSetOptionSliderScroll = () => {
  for (const productRerender of document.querySelectorAll('product-rerender[observe-form]')) {
    const formId = productRerender.getAttribute('observe-form');
    const form = formId ? document.forms[formId] : null;

    if (form) bindSetOptionSliderScroll(form);
  }
};

if (!window.__setOptionSliderScrollInit) {
  window.__setOptionSliderScrollInit = true;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSetOptionSliderScroll);
  } else {
    initSetOptionSliderScroll();
  }
}
